import { render, staticRenderFns } from "./BasePollProgress.vue?vue&type=template&id=47f98e54&scoped=true&"
import script from "./BasePollProgress.vue?vue&type=script&lang=js&"
export * from "./BasePollProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f98e54",
  null
  
)

export default component.exports